import { render, staticRenderFns } from "./AmountValue.vue?vue&type=template&id=254257ea"
import script from "./AmountValue.vue?vue&type=script&lang=js"
export * from "./AmountValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports